/**
 * Created by forbiz on 2019-02-11.
 */

const myPersonalInquery = () => {
    const saerchWinPop = () => {
        const $btn = $('#orderNumberSaerch');

        $btn
            .on('click', function(e) {
                
                const url = '/pc/greating/popup/popup_orderSearch.jsp';
                const options = 'left=0, top=0, width=800, height=740, resizeble=no, scrollbars=yes, status=no';
                window.open(url, '_blank', options);

                e.preventDefault();
            });
    };

    const myPersonalInqueryInit = () => {
        saerchWinPop();
    };

    myPersonalInqueryInit();
};

export default myPersonalInquery;